import { render, staticRenderFns } from "./ResolutionZonesDialog.vue?vue&type=template&id=9352d384&scoped=true&"
import script from "./ResolutionZonesDialog.vue?vue&type=script&lang=js&"
export * from "./ResolutionZonesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionZonesDialog.vue?vue&type=style&index=0&id=9352d384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9352d384",
  null
  
)

export default component.exports